import { useSelector } from "@/store";

export default function useAuth() {
    return useSelector((state) => state.auth.isAuthenticated);
}
  